module.exports = __webpack_public_path__ + "img/certificate02.e41093f5.png";